module.exports = __webpack_public_path__ + "img/whatsapp-icon-white.77bc130f.png";